<template>
  <div class="foobar1">
    <b-card-code
      ref="map"
      v-resize="onResize"
      title="US Map"
      style="z-index: 10; position: relative"
    >
      <l-map :zoom="zoom" :center="center" class="vue2leaflet-map">
        <l-tile-layer :url="url" />
      </l-map>

      <template #code>
        {{ codeBasic }}
      </template>
    </b-card-code>
  </div>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { LMap, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { codeBasic } from "./code";

export default {
  components: {
    LMap,
    LTileLayer,
    BCardCode,
  },
  props: {
    active: {
      type: Number,
    },
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", // Publicly available map tiles
      zoom: 4.5, // Zoom level to show the US
      center: [39.8283, -98.5795], // Geographical center of the US
      codeBasic,
    };
  },
  watch: {
    active(newVal) {
      this.reloadMap();
    },
  },
  created() {
    const data = localStorage.getItem("shippingTabNumber");
    if (data) {
      this.reloadMap();
    }
  },
  mounted() {
    this.$refs.map.mapObject._onResize();
  },
  methods: {
    onResize() {
      this.$refs.map[0].mapObject._onResize();
    },
    reloadMap: function () {
      console.log("reloading map");
      // this.$refs.map.mapObject.invalidateSize(); // Doesn't work!
      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 250);
    },
  },
};
</script>

<style scoped lang="scss">
.vue2leaflet-map {
  &.leaflet-container {
    height: 470px;
  }
}

// .foobar1 {
//   /* <--- class we added above */
//   width: 100%;
//   height: 400px;
// }
</style>
